<div class="referral-rewards">
  <div class="referral-rewards__header">
    <air-title [title]="content.title" [subtitle]="subtitle" [region]="region" [isFirst]="isFirst">
      <a
        *ngIf="content.shareLinkPage"
        class="button button--border"
        [airLink]="content.shareLinkPage._url"
        [userEventSource]="userEventSource"
      >
        {{ "referral.rewards.label.share" | translate }}
      </a>
    </air-title>
  </div>
  <p
    *ngIf="content?.description"
    class="referral-rewards__description"
    [internalInnerHtml]="content.description"
    [userEventSource]="userEventSource"
  ></p>
  <div
    class="card-list card-list--rewards"
    [ngClass]="{
      'card-list--rewards-secondary': region === contentBlockRegion.secondary,
      'card-list--rewards-highlighted': region === contentBlockRegion.highlighted
    }"
  >
    <ul class="card-list--items grid" *ngIf="!isLoading; else loading">
      <li
        *ngFor="let reward of referralRewards; let i = index"
        class="card card--reward {{ region === contentBlockRegion.highlighted ? 'col-4' : 'col-12' }} col-3--md col-4--sm"
        [ngClass]="{ activated: reward.isActivated }"
      >
        <div>
          <div class="card__image">
            <figure>
              <air-focal-image [image]="reward.image" [isCropped]="false"></air-focal-image>
            </figure>
          </div>
          <div class="card__text">
            <h4>{{ reward.title }}</h4>
          </div>
          <div *ngIf="!reward.isActivated" class="card__step">
            <p class="h1">{{ i + 1 }}</p>
          </div>
          <div *ngIf="reward.isActivated" class="sticker sticker--reward-activated sticker--md">
            <span class="sticker__label">{{ "referral.rewards.label.activated" | translate }}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

<ng-template #loading>
  <ul class="card-list--items grid">
    <li
      *ngFor="let skeleton of [] | range: 3"
      class="{{ region === contentBlockRegion.highlighted ? 'col-4' : 'col-12' }} col-3--md col-4--sm"
    >
      <air-skeleton-card [hasText]="false" [additionalClasses]="'card--no-hover'"></air-skeleton-card>
    </li>
  </ul>
</ng-template>
